import script from "./OrderStatusFilterButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusFilterButtons.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusFilterButtons.vue?vue&type=style&index=0&id=56b5dd9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b5dd9c"]])

export default __exports__